import axios, { AxiosError } from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import AjouterProduit from "../../Views/Admin/categories/AjouterProduit";
import AjouterCommercial from "../../Views/Magasin/commercial/AjouterCommercial";
import AjouterClient from "../../Views/Magasin/client/AjouterClient";

export default function AddClient(){
    const navigate = useNavigate();
    const [NomClient, setNomClient] = useState<string>("");
    const [RemiseGlobale, setRemiseGlobale] = useState<string>("");
    const [PrenomClient, setPrenomClient] = useState<string>("");
    const [NumTele, setNumTele] = useState<string>("");
    const [Credit, setCredit] = useState<string>("");
    const [Ville, setVille] = useState<string>("");
    const [ICE, setICE] = useState<string>("");
    const [Email, setEmail] = useState<string>("");
    const [Password, setPassword] = useState<string>("");
    const [MessageError, setMessageError] = useState<string>("");
    const MagasinId = localStorage.getItem('MagasinId');  
    const [showSuccessPopup, setShowSuccessPopup] = useState<boolean>(false);
    const [showErrorPopup, setShowErrorPopup] = useState<boolean>(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!NomClient || !PrenomClient || !NumTele || !Ville) {
      setMessageError("Veuillez saisir toutes les informations : nom, prénom, téléphone et ville sont obligatoires.");
      setShowErrorPopup(true);
      setTimeout(() => {
        setMessageError("");
        setShowErrorPopup(false);
      }, 3000);
      return;
    }

    if (!ICE || ICE.trim().length !== 12 || !/^\d{12}$/.test(ICE.trim())) {
      setMessageError("L'ICE est obligatoire et doit contenir exactement 12 chiffres.");
      setShowErrorPopup(true);
      setTimeout(() => {
        setMessageError("");
        setShowErrorPopup(false);
      }, 3000);
      return;
    }

    const formData = new FormData();
    formData.append("NomClient", NomClient);
    formData.append("PrenomClient", PrenomClient);
    formData.append("Tele", NumTele);
    formData.append("Ville", Ville);
    formData.append("Credit", Credit || "0");
    formData.append("ICE", ICE);
    formData.append("RemiseGlobal", RemiseGlobale || "0");
    formData.append("Email", Email);
    formData.append("Password", Password);
    // console.log("data clien " , formData);
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${MagasinId}/client/add`, formData)
      .then(({data})=>{
        setShowSuccessPopup(true);

          const timeoutId = setTimeout(() => {
          setShowSuccessPopup(false);

            navigate(`/magasins/${MagasinId}/clients`);
          }, 3000);
      });
    } catch (error: AxiosError | any) {
        setMessageError('Veuillez saisir toutes les informations : "nome" et "prenom" obligatoire "ICE doit contenir 12 chiffres ')
        setShowErrorPopup(true);
        const timeoutId = setTimeout(() => {
        setMessageError('');
        setShowErrorPopup(false);
        }, 4000);

      } 
      
    }
  return <>
  <AjouterClient
  NomClient={NomClient}
  PrenomClient={PrenomClient}
  Tele={NumTele}
  showSuccessPopup={showSuccessPopup}
  setShowSuccessPopup={setShowSuccessPopup}
  showErrorPopup={showErrorPopup}
  setShowErrorPopup={setShowErrorPopup}
  Adresse={Ville}
  credit={Credit}
  ICE={ICE}
  RemiseGlobal={setRemiseGlobale}
  setRemiseGlobale={setRemiseGlobale}
  setPrenomClient={setPrenomClient}
  setCredit={setCredit}
  setNomClient={setNomClient}
  setNumTele={setNumTele}
  setVille={setVille}
  setICE={setICE}
  setEmail={setEmail}
  setPassword={setPassword}
  handleSubmit={handleSubmit}
  MessageError={MessageError}
  setMessageError={setMessageError}

  />
  </>
}